import {Component, OnInit, Input, Output, EventEmitter} from '@angular/core';
import {FormGroup, FormBuilder, Validators} from '@angular/forms';
import {LocationService} from './location.service';
import {PlacementService} from './placement.service';

@Component({
    selector: 'location-form',
    templateUrl: './templates/location-form.component.html',
    styleUrls: ['./styles/location-form.component.css'],
    providers: [LocationService, PlacementService]
})
export class LocationFormComponent implements OnInit {

    @Output() new_emplacement = new EventEmitter();

    tmp_article_locations_list: Array<any> = [];
    showForm: boolean = true;
    location_form: FormGroup;

    location: any = {
        new_location: '',
        new_reference_parent: '',
        new_reference: '',
        reference_old: '',
        capacite_max: '',
        id_article: '',
    };

    warehouse: string;

    parents_list: Array<any> = [];

    @Input() nbr_to_place: any = 0;
    @Input() id_article: any = 0;
    @Input() quantity: any = 0;

    constructor(
        private fb: FormBuilder,
        private location_service: LocationService,
        private placement_service: PlacementService,
    ) {
        this.getLocations();
    }

    ngOnInit() {
        this.createForm();
        this.location.capacite_max = Number(this.nbr_to_place);
        this.location.id_article = this.id_article;
        this.location.quantity = this.quantity;
    }

    createForm() {
        this.location_form = this.fb.group({
            name_ctrl: ['', Validators.required],
            parent_ctrl: ['', Validators.required],
            reference_ctrl: ['', Validators.required],
            capacite_max_ctrl: ['', Validators.required],
        });
    }

    validateButton(): void {
        if (this.location_form.status === 'VALID') {
            this.insertLocation();
        }
    }

    insertLocation() {
        this.placement_service.insertLocation(this.location, this.warehouse)
            .then(result => {
                this.tmp_article_locations_list = result['list'];
                this.new_emplacement.emit(this.tmp_article_locations_list);
            });
    }

    GetLocationsList() {
        this.placement_service.GetLocationsForThisArticle(this.id_article, this.quantity)
            .then(result => {
                this.tmp_article_locations_list = result['list'];
                this.new_emplacement.emit(this.tmp_article_locations_list);
            });
    }

    defaultValue: string = '';

    getParentValue() {
        this.defaultValue = this.location.new_reference_parent + '.';
        var reftmp = this.location.new_reference;
        var val_ref = '';
        if (reftmp != null) {
            val_ref = reftmp.substring(reftmp.lastIndexOf('.') + 1);
        }
        this.location.new_reference = this.defaultValue + val_ref;
    }

    checkDefaultValue(): void {
        var oldvalue = this.location.new_reference_parent + '.';
        var reftmp = this.location.new_reference;
        var val_ref = '';
        if (this.location.new_reference.indexOf(oldvalue) === 0) {
            val_ref = reftmp.substring(reftmp.lastIndexOf('.') + 1);
        }
        this.location.new_reference = oldvalue + val_ref;
    }

    reset() {
        this.new_emplacement.emit(this.tmp_article_locations_list);
    }

    getLocations() {
        this.location_service.getLocations(this.warehouse)
            .then(result => {
                this.parents_list = result['list'];
                this.location.new_reference_parent = this.parents_list[0].reference;
                this.getParentValue();
            });
    }
}



// WEBPACK FOOTER //
// ./src/app/location-form.component.ts